<template>
	<!-- 小店订单 -->
	<div class="myorder">
		<cube-page type="myorder-view" title="小店订单" :backurl="'/shopsetting'">
			<div slot="content">
				<van-tabs v-model="active " class="leoshop-content" @change="OnChange">
					<van-tab title="全部订单" name="0">
						<van-pull-refresh v-model="refreshing[0]" @refresh="onRefresh(0)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[0].loading" :finished="vantList[0].finished"
								finished-text="没有更多了" @load="onLoad(0)" :immediate-check="false">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">
											<span>{{item.order_status_text}}</span>
										</p>
									</div>
									<van-card @click="goDetail($event,item.id,item.order_status_text)" :num="item.total_num" :title="item.goods_name" :thumb="item.goods_image">
										<template #price-top>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
											<div  v-if="item.order_status_text =='待支付'"  class="btn-div zfbtn" style="margin-left: 10px;"
												@click="onTxshow($event,item)">修改价格</div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
					<van-tab title="待确认" name="1">
						<van-pull-refresh v-model="refreshing[1]" @refresh="onRefresh(1)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[1].loading" :finished="vantList[1].finished"
								finished-text="没有更多了" @load="onLoad(1)" :immediate-check="false"
								@refresh="onRefresh(1)">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">{{item.order_status_text}}</p>
									</div>
									<van-card @click="goDetail($event,item.id)" :num="item.total_num" :price="item.goods_price"
										:title="item.goods_name" :thumb="item.goods_image">
										<template #desc>
											<div class="carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
					<van-tab title="待支付" name="2">
						<van-pull-refresh v-model="refreshing[2]" @refresh="onRefresh(2)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[2].loading" :finished="vantList[2].finished"
								finished-text="没有更多了" @load="onLoad(2)" :immediate-check="false"
								@refresh="onRefresh(2)">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">
											<span>{{item.order_status_text}}</span>
										</p>
									</div>
									<van-card @click="goDetail($event,item.id,item.order_status_text)" :num="item.total_num"
										:price="item.goods_price" :title="item.goods_name" :thumb="item.goods_image">
										<template #desc>
											<div class="carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</template>
										<template #footer style="align-items: center;">
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
											<div class="btn-div zfbtn" style="margin-left: 10px;"
												@click="onTxshow($event,item)">修改价格</div>

										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
					<van-tab title="待核销" name="3">
						<van-pull-refresh v-model="refreshing[3]" @refresh="onRefresh(3)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[3].loading" :finished="vantList[3].finished"
								finished-text="没有更多了" @load="onLoad(3)" :immediate-check="false"
								@refresh="onRefresh(3)">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">
											<span> {{item.order_status_text}}</span>
										</p>
									</div>
									<van-card @click="goDetail($event,item.id)" :num="item.total_num" :price="item.goods_price"
										:title="item.goods_name" :thumb="item.goods_image">
										<template #desc>
											<div class="carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
					<van-tab title="已完成" name="4">
						<van-pull-refresh v-model="refreshing[4]" @refresh="onRefresh(4)">
							<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="vantList[4].loading" :finished="vantList[4].finished"
								finished-text="没有更多了" @load="onLoad(4)" :immediate-check="false"
								@refresh="onRefresh(4)">
								<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">{{item.order_status_text}}</p>
									</div>
									<van-card @click="goDetail($event,item.id)" :num="item.total_num" :price="item.goods_price"
										:title="item.goods_name" :thumb="item.goods_image">
										<template #desc>
											<div class="carddesc">
												{{item.goods_sku}}
											</div>
										</template>
										<template #price-top>
											<div class="carddesc">
												<span>使用时间：</span>
												<span>{{item.use_date}}</span>
											</div>
											<div class="carddesc">
												<span>下单时间：</span>
												<span>{{item.createtime}}</span>
											</div>
										</template>
										<template #footer>
											<div class="item">总价¥<span class="price"
													v-html="decimalPoint(item.total_price)"></span></div>
											<div class="item blodspan">实付款¥<span class="price"
													v-html="decimalPoint(item.pay_price)"></span></div>
										</template>
									</van-card>
								</div>
							</van-list>
						</van-pull-refresh>
					</van-tab>
				</van-tabs>
			</div>
		</cube-page>
		<cube-view></cube-view>
		<van-popup v-model="txshow" round style="width: 280px;">
			<div class="qrshow">
				<div class="titlebox">
					<p class="title">修改价格</p>
					<p class="right" @click="txshow=false">
						<van-icon name="close" />
					</p>
				</div>
				<van-form @submit="onSubmitTx">
					<!-- 允许输入正整数，调起纯数字键盘 -->
					<van-field v-model="xgprice" name="number" type="number" label="修改价格￥" :colon="true"
						placeholder="请输入修改价格" />
					<div style="margin: 16px;">
						<van-button round block type="info" native-type="submit">提交</van-button>
					</div>
				</van-form>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'

	import {
		Toast
	} from 'vant';
	export default {
		components: {
			CubePage,
			CubeView,
		},
		data() {
			return {
				vantList: [{
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}, {
					loading: false,
					finished: false
				}],
				refreshing: [false, false, false, false, false],
				store: null,
				OrderList: [],
				active: this.$route.params.showType == undefined ? 0 : this.$route.params.showType,
				isNoData: false,
				gcfg: [],
				pageIndex: 1,
				pageTotal: 0,
				txshow: false,
				xgprice: '',
				selectId: '',
				statusid: 0
			};
		},
		created() {
			this.gcfg = this.$store.getters.getGcfg
			this.store = this.$store.getters.getShop
			this.get_my_order(this.active)
		},
		methods: {
			// 修改价格
			// 价格修改
			onSubmitTx() {
				var url = "/addons/litestore/api.store/editPayPrice"
				let that = this
				//这里直接调用网络接口
				util.post(url, {
						store_id: that.store,
						id: that.selectId,
						amount: that.xgprice
					},
					function(result) {
						Toast.success(result.msg);
						that.txshow = false
						that.OrderList = []
						that.pageIndex = 1
						that.pageTotal = 0

						that.clearContainer();
						that.get_my_order(that.active);
					},
				);
			},
			//修改价格框展示
			onTxshow(event,item) {
				let that = this
				console.log(event)
				event.preventDefault()
				if (event.target.innerText != '修改价格') {
					return;
				}
				that.selectId = item.id
				that.xgprice = item.pay_price
				that.txshow = true
			},
			// 跳转详情页
			goDetail(event,id) {
				// 阻止a标签跳转
				event.preventDefault()
				if (event.target.outerText == '修改价格') {
					return;
				}
				let update = false
				if (status == '待支付') {
					update = true
				}
				this.$router.push({
					path: 'leoorder/detail',
					query: {
						id: id,
						isshop: '11',
						update: update
					}
				})
			},
			onRefresh(status) {
				// 清空列表数据
				this.vantList[status].finished = false;

				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态

				this.vantList[status].loading = true;
				this.get_my_order(status);
			},
			// 上滑加载更多
			onLoad(status) {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				this.statusid = status;
				setTimeout(() => {
					that.get_my_order(status);
				}, 100)
			},
			// 获取数据
			get_my_order(status) {
				var url = "/addons/litestore/api.store/orderList"
				let that = this;
				status = (status == '' || status == undefined || status == null) ? 0 : status;
				if (that.refreshing[status]) {
					that.clearContainer();
					that.refreshing[status] = false;
				}
				if (that.pageIndex > 1 && that.OrderList.length >= that.pageTotal) {
					that.vantList[status].finished = true;
					return;
				}
				let param = {
					status: status == 0 ? '' : status,
					page: that.pageIndex,
					store_id: that.store
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						that.isNoData = false
						that.vantList[status].loading = false;
						//这里对状态 进行分类
						that.pageTotal = result.data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (result.data.list == null || result.data.list.length === 0) {
							// 加载结束
							that.vantList[status].finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.OrderList = that.OrderList.concat(result.data.list);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.OrderList.length >= that.pageTotal) {
							that.vantList[status].finished = true;
						}
					},
				);
			},

			OnChange(name, title) {
				let that = this;
				that.receiptStatus = ''
				that.payStatus = ''
				if (name != '0') {
					if (name == '10' || name == '20') {
						//待支付，已取消
						that.payStatus = '10'
					} else {
						that.payStatus = '20'
					}
				}
				if (name == '31') {
					that.receiptStatus = 10
				} else if (name == '30') {
					that.receiptStatus = 20
				}
				that.clearContainer()
				that.get_my_order(name)
			},
			// 初始化数据
			clearContainer() {
				this.vantList = [{
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}, {
						loading: false,
						finished: false
					}],
					this.OrderList = [],
					this.isNoData = false,
					this.pageIndex = 1,
					this.pageTotal = 0
			},
			decimalPoint(val) {
				const splitPrice = (val || '0.00').split('.');
				const numb1 = splitPrice[0];
				var numb2 = '00';
				if (splitPrice.length > 1) {
					numb2 = splitPrice[1];
				}
				return `${numb1}.<span style="font-size: 12px; line-height: 12px;">${numb2}</span>`;
			}
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			"$store.state.shop"() {
				this.store = this.$store.getters.getShop
			}
		},
	}
</script>
<style lang="less" scoped="scoped">
	@import url("../../assets/css/order.css");
	@import url("../../assets/css/listboxless.less");
</style>
<style type="text/css">
	/* 	.zfbtn{
		padding: 2px 5px;
		border-radius: 5px;
	} */
	.van-card__footer {
		height: 40px;
		align-items: center;
	}

	.van-card {
		background: transparent !important;
	}
</style>
